import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchUsers } from "../../redux/action";

function RestaurantProfile(params) {

    const { restaurantId } = useParams()
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchUsers(restaurantId))
    }, [])
    return (
        <h1>Restaurant Profile Page for {restaurantId}</h1>
    )
    // todo:
    // This page is dedicated to perticular Restaurant and the Restaurant group
    // Restaurant Profile page includes:
    // - Link to navigate to the menu list of the restaurent
    // - Image
    // - Loaction / Address
    // - Contact
    // - Official Website (if available)
    // - Call us / WhatsApp - other link to connect to the restaurents
    // - Other Services or customised message given by Restaurant Admin
    // - Google Rating Image, with update date
    // - Controlled by Restaurent owner 

    // We also, need to think to think on dupliacte name logic
}

export default RestaurantProfile;